const railsEnv = document.head.querySelector('meta[name=rails-env]') as HTMLMetaElement;

window.RailsEnv = railsEnv.content;

const railsLegacy = document.head.querySelector('meta[name=rails-legacy]') as HTMLMetaElement | null;

window.RailsLegacy = Boolean(railsLegacy?.content);

export {};
